<template>
    <section v-if="hasPermissions(['Building-Cost-Center Write', 'Building-Cost-Center Read', 'Building-Cost-Center Cost-Center-Upload'])" class="view">
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <h1 class="view__title title--1">
            {{ title_page }}
        </h1>
        <div class="view__description">
            <p class="view__description__text">
                This is a list of all Cost Centers within your Facility. Click "Add Cost Center" to create a new Cost Center. Cllicking "Mass Delete" will delete the Cost Center and all Rooms within the Cost Center.
            </p>
        </div>

        <div class="bar-container">
            <div class="bar-container__search-bar">
                <div class="input-field my-0" v-if="cost_centers.length && hasPermissions(['Building-Cost-Center Read'])">
                    <i class="material-icons prefix iconInput">search</i>
                    <input id="icon_prefix" type="text" class="validate inputSearch" placeholder="Search" v-model="search">
                </div>
            </div>

            <div class="bar-container__options">
                <UploadOptions
                    :ref="'file_excel'"
                    :empty_format_data="empty_format_data"
                    :excel_file_headers="excel_file_headers"
                    :file_name="'cost_center_file'"
                    @data="upload($event)"
                    v-if="hasPermissions(['Building-Cost-Center Cost-Center-Upload'])"
                />
                <button v-if="hasPermissions(['Building-Cost-Center Write'])" class="modal__buttons__item w-auto px-3" v-html="'Mass Delete'" :class="{'disabled button__disabled' : !selected}" :disabled="!selected" @click="massive_modal_delete()"/>
            </div>

            <div v-if="hasPermissions(['Building-Cost-Center Write'])" class="bar-container__cta">
                <span class="button__modal text-right">
                    <a href="#" @click="form_modal()" class="d-inline-md-block">
                        {{ add_btn }}
                        <i class="prefix ml-1">
                            <img src="/assets/img/svg/add.svg" alt="date" style="width: 15px">
                        </i>
                    </a>
                </span>
            </div>
        </div>

         <div class="tab-content" v-show="cost_centers.length && hasPermissions(['Building-Cost-Center Read'])">
            <div class="tab-pane fade active show" id="listation">
                <div class="row mb-0 no-gutters">
                    <div class="col-lg-12">
                        <v-card>
                            <DinamicTable
                                :headers="table_headers"
                                :items="cost_centers"
                                :search="search"
                                :checkable="true"
                                :link="'#'"
                                :updateable="true"
                                @emitToUpdate="modal_update($event)"
                                @emitAction="emitAction($event)"
                                ref="dinamic_table"
                            />
                        </v-card>
                    </div>
                </div>
            </div>
        </div>
    
        <DeletionModal 
            :single_object="single_object" 
            :global_index="global_index" 
            @objectDeletion="object_deletion($event)"
        />

        <DeletionMassiveModal
            @objectDeletion="massive_local_emition($event)"
        />

        <FormModal 
            :title="'New Cost Center'"
            :breadcrumb="breadcrumb"
            :rest_api="rest_api"
            :notyf="notyf"
            :axios="axios"
            :array_options="array_options"
            @unshiftObject="unshift_object($event)"
        />

        <UpdateModal 
            :title="'Cost Center Update'"
            :breadcrumb="breadcrumb"
            :rest_api="rest_api"
            :notyf="notyf"
            :axios="axios"
            :single_object="single_object"
            :global_index="global_index"
            :array_options="array_options"
            @spliceObject="splice_object($event)"
        />

        <WaitingModal/>

        <UploadSummary
            :breadcrumb="breadcrumb"
            :summary="summary"
            :excel_file_headers="excel_file_headers"
            :excel_data="excel_data"
            :file_name="'cost_centers_falied_template_file'"
        />

        <HelperModal :helps="helps"/>

  </section>
    <div v-else>
        <UnauthorizedComponent :breadcrumb="breadcrumb"/>
    </div>
</template>

<script>

import axios                from    'axios';
import Breadcrumb           from    '@/components/BreadcrumbComponent/Breadcrumb'
import WaitingModal         from    '@/components/WaitingModal'
import HelperModal          from    '@/components/HelperModal'
import Resources            from    './resources'
import FormModal            from    './FormModal'
import UpdateModal          from    './UpdateModal'
import DeletionModal        from    '@/components/DeletionModal'
import DinamicTable         from    '@/components/DinamicTable'
import { Notyf }            from    'notyf';
import DeletionMassiveModal from    '@/components/DeletionMassiveModal'
import UploadOptions        from    '@/components/UploadOptions'
import UploadSummary        from    '@/components/UploadSummary'
import UnauthorizedComponent from   '@/components/UnauthorizedComponent'

import 'vuetify/dist/vuetify.min.css'
import 'notyf/notyf.min.css'; // for React and Vue
const notyf = new Notyf({
    duration: 8000,
});

export default {

    name:   'CostCenter',

    components:{
        Breadcrumb,
        WaitingModal,
        DeletionModal,
        FormModal,
        UpdateModal,
        DinamicTable,
        DeletionMassiveModal,
        UploadOptions,
        UploadSummary,
        UnauthorizedComponent,
        HelperModal
    },

    data(){
        return {
            notyf,
            child_href:              '/building-cost-center/',
            axios,
            user:                    this.get_user(),
            title_page:             'Cost Center',
            rest_api:               `cost_center`,
            table_headers:          Resources.table_headers,
            breadcrumb:             Resources.breadcrumb,
            excel_file_headers:     Resources.excel_file_headers,
            empty_format_data:      Resources.empty_format_data,
            excel_fields_required:  Resources.excel_fields_required,
            add_btn:                'Add Cost Center',
            single_select:          false,
            table_selection:        [],
            search:                 '',
            global_index:           0,
            single_object:          {},
            cost_centers:           [],
            array_options:          {},
            select_ids:             [],
            summary:                [],
            excel_data:             [],
            helps:                  Resources.helps
        }
    },
    
    methods:{
        unshift_object(new_object)
        {
            this.cost_centers.unshift(new_object)
        },

        splice_object(splicing_object)
        {
            this.cost_centers.splice(splicing_object.index, 1, splicing_object.single_object)
        },

        form_modal()
        {
            if(!this.user.has_facility)
            {
                notyf.error('There is not exists a facility yet')
                return false
            }
            window.$('#static').modal('show')
        },

        modal_deletion(index)
        {
            this.global_index  = index
            this.single_object = this.cost_centers[index]
            window.$('#static-deletion').modal('show')
        },

        modal_update(index)
        {
            this.global_index  = index
            this.single_object = {...this.cost_centers[index]}
            window.$('#static-update').modal('show')
        },

        fill_data(data)
        {
            this.cost_centers = data.cost_center
        },

        emitAction(data)
        {
            if(data.header == 'room_counter_record')
            {
                const cost_center_id = this.$refs.dinamic_table.display_items[data.index].decrypted_id || null;
                this.$router.push(`/building-rooms?cost_center_id=${cost_center_id}`)
            }
        },

        trashing(index)
        {
            this.cost_centers.splice(index, 1)
        },

        massive_modal_delete()
        {
            this.select_ids = this.cost_centers.filter(item => item.checked).map(item => item.id)
            if(this.select_ids.length)
            {
                window.$('#static-deletion-massive').modal('show')
            }
        },

        async massive_local_emition()
        {
            let json_request = {
                ids:         this.select_ids,
            }

            let sendingMassive = await this.massive_delete(json_request)

            if(sendingMassive)
            {
                this.select_ids.forEach( item =>
                {
                    const index = this.cost_centers.findIndex(value => value.id == item)
                    if(index > -1)
                    {
                        this.cost_centers.splice(index, 1)
                    }
                })
                this.select_ids = []
            }
        },

        async upload(data)
        {
            const send_data = []
            this.excel_data = []

            for ( const value of data ) {
                const entity = {}

                for (const prop in this.excel_file_headers) {

                    entity[this.excel_file_headers[prop]] = this.parse_boolean(value[prop])
                }
                this.excel_data.push({... entity})

                send_data.push(entity)
            }

            this.loader(true)
            const response = await this.post(`${this.rest_api}/massive`, { cost_centers: send_data })
            this.loader()

            if(response.status)
            {
                notyf.success('Success!')
                this.summary = response.data.summary
                window.$('#upload-summary').modal('show')

                for (const cost_center of response.data.cost_centers) 
                {
                    this.unshift_object(cost_center);
                }
            }
            else
            {
                this.error_handling(response)
            }
            
            this.$refs.file_excel.clear_data()
        },
    },

    async mounted()
    {
        if(this.hasPermissions(['Building-Cost-Center Read']))
        {
            await this.api_request()
        }
    },

    computed:
    {
        selected()
        {
            const bool = this.cost_centers.filter(item => item.checked)
            return Boolean(bool.length)
        }
    }
}

</script>